<template>
  <div class="fh-ellipsis" :data-link="link ? 'main-field' : ''">
    <jw-tooltip v-if="isOverflow" :content="content" placement="top">
      <div ref="container" class="ellipsis-content">{{ content }}</div>
    </jw-tooltip>
    <div ref="container" v-else class="normal-content">{{ content }}</div>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, nextTick, watch, inject } from 'vue';
import { useThrottleFn, useDebounceFn } from '@vueuse/core';
import useTableSearch from '@/hooks/fh-table-search';
const { highlightTextLocal } = useTableSearch();
const searchKeywords = inject('defaultParams')?.keywords; // 搜索关键词
const fieldShowInfo = inject('fieldShowInfo');

const props = defineProps({
  content: {
    type: String,
    required: true
  },
  link: {
    type: Boolean,
    default: false
  },
  lineHeight: {
    type: [Number, String],
    default: 22 // 默认行高
  }
});

const container = ref(null);
const isOverflow = ref(false);
let resizeObserver = null;
// const contentStyle = ref({});

// 使用节流函数包装 checkOverflow，减少频繁调用
const checkOverflow = useThrottleFn(() => {
  const element = container.value;
  if (element) {
    // 单行省略模式下检查溢出
    isOverflow.value = element.scrollWidth > element.clientWidth;
    if (searchKeywords?.value) {
      nextTick(() => {
        highlightTextLocal(searchKeywords.value, container.value, fieldShowInfo);
      });
    }
  }
}, 100); // 100ms 的节流时间

// 使用防抖函数处理 watch 回调，减少频繁计算
const debouncedUpdate = useDebounceFn(() => {
  nextTick(checkOverflow);
}, 200); // 200ms 的防抖时间

watch([() => props.content, () => props.wrapHeight, () => props.lineHeight], debouncedUpdate);

// checkOverflow();

onMounted(() => {
  checkOverflow();

  // 使用 ResizeObserver 监听容器大小变化，并使用节流函数
  resizeObserver = new ResizeObserver(
    useThrottleFn(() => {
      checkOverflow();
    }, 200)
  );

  if (container.value) {
    resizeObserver.observe(container.value);
  }
});

onBeforeUnmount(() => {
  // 清理 ResizeObserver
  if (resizeObserver) {
    resizeObserver.disconnect();
    resizeObserver = null;
  }
});
</script>

<style lang="less" scoped>
.fh-ellipsis {
  max-width: 100%;

  .ellipsis-content {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    word-break: break-word;
    overflow-wrap: break-word;
  }

  .normal-content {
    white-space: nowrap;
    text-overflow: ellipsis;
    // word-break: break-word;
  }
}

/* 当使用wrapHeight时，样式会通过contentStyle动态设置 */
</style>
